<template>
  <section>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(saveFinancing)">
        <!-- Box de Formulario Evento -->
        <div class="modal-card" style="width: auto" id="modal-event">
          <header class="modal-card-head">
            <p class="modal-card-title">{{modalHeader}}</p>
            <button
                type="button"
                class="delete"
                @click="$emit('close')"/>
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <b-field>
                  <template #label>
                    Seleccione institución de financiamiento*
                    <b-tooltip
                        label="Presione Enter o seleccione la institución de financiamiento luego de escribir"
                        position="is-right"
                        multilined>
                      <b-icon
                          pack="fas"
                          icon="info-circle"
                          type="is-info">
                      </b-icon>
                    </b-tooltip>
                  </template>
                  <ValidationProvider rules="required" v-slot="{errors}">
                    <b-taginput
                        v-model="entidad_seleccionada"
                        :data="entidades_filtradas"
                        type="is-primary is-light"
                        autocomplete
                        :allow-new="false"
                        field="name"
                        icon="tag"
                        maxtags="1"
                        placeholder="Seleccione institución de financiamiento"
                        @typing="getFilteredEntidad">
                    </b-taginput>

                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Seleccione Tipo de Financiamiento*">
                  <ValidationProvider rules="required" v-slot="{errors}">
                    <multiselect v-model="financings_attributes.financing_type_id"
                                 :options="tipos_financiamiento.map(x => x.id)"
                                 :custom-label="opt => tipos_financiamiento.find(x => x.id == opt).name"
                                 placeholder="Seleccione tipo de financiamiento"
                                 selectLabel="Presione para seleccionar"
                                 selectedLabel="Seleccionado"
                                 deselectLabel="No se puede deseleccionar"
                                 :allow-empty="false">
                      <template v-slot:noOptions>
                        No existen datos
                      </template>
                      <span slot="noResult">
                          No se encontraron elementos.
                        </span>
                    </multiselect>
                    <span class="validation-alert">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-field>
              </div>
            </div>
            <div class="columns">
                <div class="column">
                  <b-field label="Año*">
                    <ValidationProvider rules="integer|min_value:1900|required" v-slot="{errors}">
                      <b-input v-model="financings_attributes.year"></b-input>
                      <span class="validation-alert">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>
                <div class="column">
                  <b-field label="Monto($)*">
                    <ValidationProvider rules="integer|positive|required" v-slot="{errors}">
                      <b-input :has-counter="false" maxlength="14" v-model="financings_attributes.amount"></b-input>
                      <span class="validation-alert">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>
              </div>
          </section>
        </div>
        <footer class="modal-card-foot actions">
          <div class="field is-grouped is-pulled-right">
            <button class="button" type="button" @click="$emit('close')">Cerrar</button>
            <button class="button is-primary" type="submit" :disabled="isDisabled">Agregar</button>
          </div>
        </footer>
      </form>
    </ValidationObserver>
    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
  </section>
</template>
<script>
import axios from "axios";
const qs = require('qs')
export default {
  name: "modal_financing_project",
  props:[
    'queryType', 'personId', 'id', 'modalHeader', 'projectId', 'participantes', 'tipo', 'entidad', 'actual_financing', 'actual_index'
  ],
  data(){
    return {
      project:{},
      financings_attributes:{
        amount: null,
        year: null,
        financing_type_id: null,
        partner_entity_id: null

      },
      entidades_filtradas:[],
      cardLayout:false,
      entidad_seleccionada: [],
      errores_validacion:[],
      tipos_financiamiento: null,
      entidades_externas: null,
      isLoading:false,
      isDisabled: false,

    }
  },
  created() {
    this.isLoading=true;
    this.tipos_financiamiento = this.tipo
    this.entidades_externas = this.entidad

    if (this.actual_index != null){
      this.financings_attributes.year = this.actual_financing.year
      this.financings_attributes.amount = this.actual_financing.amount
      this.financings_attributes.financing_type_id = this.actual_financing.financing_type_id
      this.entidad_seleccionada.push(this.entidades_externas.find(x => x.id == this.actual_financing.partner_entity_id))
    }

    this.isLoading=false;
  },
  methods: {
    saveFinancing(){
      this.financings_attributes.partner_entity_id = this.entidad_seleccionada[0].id
      this.$emit('clicked', this.financings_attributes)
      this.$emit('close')
    },
    getFilteredEntidad(text) {
      this.entidades_filtradas = this.entidades_externas.filter((option) => {
        return option.name
            .toString()
            .toLowerCase()
            .indexOf(text.toLowerCase()) >= 0
      })
    },
  }
}
</script>
